<script>
export default {
  data() {
    return {};
  },
  created() {
    const token = this.queryString.token;
    dsf.storage.session.set("authorization_token", token);
    const goUrl = decodeURIComponent(this.queryString.goUrl);
    location.replace(goUrl);
  },
};
</script>
